import createInstance from './axios';
import { ObjectSubtypeDto } from 'types/dto/contracts-service';

const DevicesAPI = createInstance('CONTRACTS');

export const getTypes = () => {
  return DevicesAPI.get<ObjectSubtypeDto[]>('/insurance-objects/types-subtypes/');
};
